webpackJsonp([18],{

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);




var moremoreClick = function moremoreClick() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-guideMoreButton').on('click', '', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-faq li:gt(9)').fadeIn(1000);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-guideMoreButton').fadeOut(1000).remove();
  });
};

var start = function start() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-faq li:gt(9)').hide();

  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-faq li').length <= 10) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-guideMoreButton').remove();
  }
};

var filterData = function filterData(word) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-helpSearch-item').each(function (index, val, array) {
    if (new RegExp(word, 'i').test(val.textContent) || new RegExp(word, 'i').test(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).data('sub-content')) || new RegExp(word, 'i').test(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').find('.js-helpSearch-title').text())) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).css('display', 'block').addClass('is-block');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).css('display', 'none').removeClass('is-block');
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).next().length) {
      if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).siblings().hasClass('is-block') && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).hasClass('is-block')) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').css('display', 'none').removeClass('is-block');
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').css('display', 'block').addClass('is-block');
      }
      if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').next().length) {
        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').siblings().hasClass('is-block') && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').hasClass('is-block')) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').parent().css('display', 'none').removeClass('is-block').prev().css('display', 'none').removeClass('is-block');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(val).closest('.js-helpSearch-block').parent().css('display', 'block').addClass('is-block').prev().css('display', 'block').addClass('is-block');
        }
      }
    }
  });
};

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  start();
  moremoreClick();

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.a-helpInput').bind('keyup', function (e) {
    var searchWord = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget).val();
    filterData(searchWord);
  });
});

/***/ })

},[125]);


// WEBPACK FOOTER //
// assets/js/help.js